import { Route } from 'types/route.type';

import { routes as feedStrategies } from './features/feed-strategies/routes';
import { routes as marketProfiles } from './features/market-profiles/routes';
import { routes as profiles } from './features/profiles/routes';
import { routes as siteProfiles } from './features/site-profiles/routes';

export const routes: Route[] = [...feedStrategies, ...profiles, ...siteProfiles, ...marketProfiles];
